import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'

import { apiSend } from '../lib/api'
import { supabase } from '../lib/supabase'
import type { Me } from '../lib/types'

/**
 * Первый и единственный обязательный вопрос: какой экзамен.
 *
 * От него зависят цель, оценка балла и подбор задач, поэтому спрашиваем явно и
 * до всего остального. Цель и срок ставятся потом, на экране прогресса, — не
 * стоит держать новичка в анкете, пока он не увидел ни одной задачи.
 */
export default function Onboarding({ me }: { me: Me }) {
  const queryClient = useQueryClient()
  const [busy, setBusy] = useState('')
  const [error, setError] = useState('')

  async function choose(slug: string) {
    setBusy(slug)
    setError('')
    try {
      await apiSend('/api/me', 'PATCH', { exam: slug })
      await queryClient.invalidateQueries({ queryKey: ['me'] })
    } catch {
      setError('Не удалось сохранить выбор. Попробуй ещё раз.')
      setBusy('')
    }
  }

  return (
    <main className="app-main" style={{ maxWidth: 460 }}>
      <h1>Привет, {me.name}!</h1>
      <p className="muted">
        К какому экзамену готовишься? По нему я считаю цель, оценку балла и подбираю
        задачи. Поменять можно в любой момент.
      </p>

      {error && <div className="error">{error}</div>}

      <div className="list" style={{ marginTop: 20 }}>
        {me.exams.map((exam) => (
          <button
            key={exam.slug}
            className="btn btn-lg btn-block"
            disabled={busy !== ''}
            onClick={() => choose(exam.slug)}
          >
            {busy === exam.slug ? 'Сохраняем…' : exam.code}
          </button>
        ))}
      </div>

      <button
        className="btn btn-block"
        style={{ marginTop: 24 }}
        onClick={() => supabase.auth.signOut()}
      >
        Выйти
      </button>
    </main>
  )
}
